import { BASE_STYLES, BASE_SPACING } from './constants.js';
import { generateShouldForwardPropsConfig } from '@doordash/utilities';
import '../themes/default/borderRadius/index.js';
import '../themes/default/borderWidth/index.js';
import '../themes/default/color/index.js';
import '../themes/default/shape/index.js';
import '../themes/default/size/index.js';
import { SpacingAll } from '../themes/default/spacing/index.js';
import '../theming/themes/caviar.js';
import '../theming/themes/merchant.js';
import '../theming/themes/merchant-next.js';
import '../theming/themes/internal-tools.js';
import '../theming/icons/constants.js';
import '../theming/logo/constants.js';
import '../theming/typography/constants.js';
import 'lodash.clonedeep';
import 'lodash.merge';
import React from 'react';
import styled from 'styled-components';

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var StyledStack = styled.div.withConfig(generateShouldForwardPropsConfig(['size'])).withConfig({
  displayName: "Stack__StyledStack",
  componentId: "sc-vzfcgq-0"
})(["", " margin-bottom:", "px;"], BASE_STYLES, function (props) {
  return props.size;
});

var Stack = function Stack(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? BASE_SPACING : _ref$size,
      children = _ref.children,
      tag = _ref.tag,
      props = _objectWithoutProperties(_ref, ["size", "children", "tag"]);

  return /*#__PURE__*/React.createElement(StyledStack, _extends({
    as: tag,
    size: size
  }, props), children);
};

Stack.Sizes = SpacingAll;

export { Stack as default };
